import { render, staticRenderFns } from "./ValuationVersionCardContent.vue?vue&type=template&id=02be8bed&"
import script from "./ValuationVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./ValuationVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports